import { useQuery } from "@tanstack/react-query";
import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import axiosaim from "../../../api/axiosaim";
import Departments from "../../../components/settings/approvals/Department";
import ApprovalOutlet from "../../../components/settings/approvals/Approvals";
import Loader from "../../../components/loader/Loader";
import toast from "../../../components/sweetalert/Sweetalert";

const Approvals = () => {
    const navigate = useNavigate();

    const aimtoken = sessionStorage.getItem('aimtoken') || '';
    const department = sessionStorage.getItem('department') || '';
    const departmentslug = sessionStorage.getItem('departmentslug') || '';
    const uname = sessionStorage.getItem('uname'); 

    const [employeeUname, setEmployeeUname] = useState('all');

    const { data: manageddepartments, isLoading: isLoadingDepartments } = useQuery({
        queryKey: ['managedAIMDepartments', uname],
        queryFn: async () => {
            const res = await axiosaim.get(`getmanageddepartments`, {
                headers: { 'X-Aim-Token': aimtoken }
            });
            return res.data;
        },
        enabled: !!uname && !!aimtoken,
        retry: 1
    });

    useEffect(() => {
        if (manageddepartments?.length === 0) {
            navigate('/error');
        }
    }, [manageddepartments]);

    const { data: employees, error: errorEmployees } = useQuery({
        queryKey: ['departmentEmployees', {departmentslug}],
        queryFn: async () => {
            const res = await axiosaim.get(`getuserlistsperdepartment?d=${departmentslug}`, {
                headers: { 'X-Aim-Token': aimtoken }
            });
            return res.data;
        },
        enabled: !!departmentslug && !!aimtoken
    });
    
    useEffect(() => {
        if (errorEmployees) {
            toast.fire({ icon: 'error', title: 'No user(s) found.' });
        }
    }, [errorEmployees]);

    return (
        <div className="approvals">
            <div className="page-header">
                <div className="title">
                    <h1>Approvals</h1>
                    <ul className="breadcrumbs">
                        <li>
                            <NavLink to="/settings/devices">Settings</NavLink>
                        </li>
                        <li>
                            <span>Approvals</span>
                        </li>
                        {manageddepartments?.length === 1 && (  
                            <li>                                  
                                <select onChange={(e) => { setEmployeeUname(e.target.value) }}>
                                    <option value="all">All</option>
                                    {employees?.length > 0 ? (
                                        employees?.map((item) => (
                                            <option key={item.uname} value={item.uname}>
                                                {item.fname} {item.lname}
                                            </option>
                                        ))
                                    ) : (
                                        <option value="">--</option>
                                    )}
                                </select>
                            </li>
                        )}
                    </ul>
                </div>
            </div>

            {isLoadingDepartments 
                ? (
                    <div className="columns">
                        <Loader />
                    </div>
                ) 
                : manageddepartments?.length > 1
                    ? (
                        <Departments departments={manageddepartments} loading={isLoadingDepartments} employeeUname={employeeUname} />
                    ) : (
                        <ApprovalOutlet departmentname={department} departmentslug={departmentslug} employeeUname={employeeUname} />
                    )
            }
        </div>
    );
};

export default Approvals;
